// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as OpeningButton from "../../resources/actions/OpeningButton.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";
import * as CartProductFeesPopover from "./CartProductFeesPopover.res.js";
import * as CartProductFeeFieldset__Utils from "./CartProductFeeFieldset__Utils.res.js";

function CartProductFeesTableCell(props) {
  let dispatch = props.onRequestDispatch;
  let product = props.product;
  let __editable = props.editable;
  let editable = __editable !== undefined ? __editable : false;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1;
  let exit = 0;
  let fees;
  let id;
  let unitFee;
  if (product.TAG === "Unit") {
    let match$2 = product._0;
    fees = match$2.fees;
    id = match$2.id;
    unitFee = match$2.unitFee;
    exit = 1;
  } else {
    let match$3 = product._0;
    fees = match$3.fees;
    id = match$3.id;
    unitFee = match$3.unitFee;
    exit = 1;
  }
  if (exit === 1) {
    let formattedUnitFee = Stdlib_Option.map(unitFee, value => I18n.currencyFormat(undefined, "EUR", 3, 3, value.toNumber()));
    match$1 = [
      id,
      fees,
      formattedUnitFee
    ];
  }
  let fees$1 = match$1[1];
  let productId = match$1[0];
  React.useEffect(() => {
    if (popover.isOpen && fees$1.length === 0) {
      dispatch({
        TAG: "ProductFeeAdded",
        _0: productId
      });
    }
  }, [popover.isOpen]);
  let renderFeesTooltip = React.useMemo(() => JsxRuntime.jsx(TooltipIcon.make, {
    children: Stdlib_Array.filterMap(fees$1, fee => {
      let amount = fee.amount;
      if (amount <= 0) {
        return;
      }
      let formattedAmount = I18n.currencyFormat(undefined, "EUR", 3, 3, amount);
      let formattedFee = CartProductFeeFieldset__Utils.optionToText(fee.kind) + ` : ` + formattedAmount;
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(Tooltip.Span.make, {
            text: formattedFee
          }),
          JsxRuntime.jsx(Tooltip.Gap.make, {
            space: "xxsmall"
          })
        ]
      });
    }),
    variation: "info"
  }), [fees$1]);
  let match$4 = fees$1.length !== 0;
  let totalAmountElement = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(ProductPriceTableCell.make, {
        value: match$1[2]
      }),
      editable || !match$4 ? null : renderFeesTooltip
    ],
    space: "small"
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      editable ? JsxRuntime.jsx(OpeningButton.make, {
          children: totalAmountElement,
          ariaProps: popoverAriaProps.triggerProps,
          opened: popover.isOpen,
          onPress: param => popover.toggle(),
          ref: popoverTriggerRef
        }) : totalAmountElement,
      popover.isOpen ? JsxRuntime.jsx(CartProductFeesPopover.make, {
          product: product,
          popover: popover,
          popoverAriaProps: popoverAriaProps,
          popoverTriggerRef: popoverTriggerRef,
          onRequestProductFeeAdd: () => dispatch({
            TAG: "ProductFeeAdded",
            _0: productId
          }),
          onRequestProductFeeUpdate: (feeId, updatedFee) => dispatch({
            TAG: "ProductFeeUpdated",
            _0: productId,
            _1: feeId,
            _2: updatedFee
          }),
          onRequestProductFeeReplicate: fee => dispatch({
            TAG: "ProductFeeReplicated",
            _0: fee
          }),
          onRequestProductFeeRemove: feeId => dispatch({
            TAG: "ProductFeeRemoved",
            _0: productId,
            _1: feeId
          })
        }) : null
    ]
  });
}

let make = React.memo(CartProductFeesTableCell, (oldProps, newProps) => {
  if (oldProps.product === newProps.product) {
    return oldProps.editable === newProps.editable;
  } else {
    return false;
  }
});

let Utils;

export {
  Utils,
  make,
}
/* make Not a pure module */
